import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import Loading from "../../compnents/common/Loading";
import { jwtTokenLogin } from "../../store/api/auth";

const JWTTokenAuth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  const token = searchParams.get("token");
  const isIframe = searchParams.get("iframe") === "true";

  const { mutate: authenticateWithJWT, isPending } = useMutation({
    mutationFn: jwtTokenLogin,
    onSuccess: (data) => {
      console.log(data);
      // Store authentication data
      localStorage.setItem("organisationId", data.organizationId);
      localStorage.setItem("companyName", data.organizationName);
      localStorage.setItem("isOnBoarded", data.isOnboarded);

      localStorage.setItem("token", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);

      localStorage.setItem("isIframeMode", true);

      // Set user data if available
      if (data.user) {
        localStorage.setItem("userId", data.user.id);
        localStorage.setItem("userRole", data.user.role);
      }
      if (data.errors) {
        setError(error.response?.data?.message || "Authentication failed");
        console.error("JWT Authentication error:", error);
      }

      // Navigate to dashboard
      setTimeout(() => {
        navigate(`/${data.companyName}/dashboard`);
      }, 0);
    },
    onError: (error) => {
      setError(error.response?.data?.message || "Authentication failed");
      console.error("JWT Authentication error:", error);
    },
  });

  useEffect(() => {
    if (token) {
      authenticateWithJWT({ token });
    } else {
      setError("Missing required parameters (token or orgId)");
    }
  }, [token, authenticateWithJWT]);

  if (isPending) {
    return <Loading />;
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <h2>Authentication Error</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Try Again</button>
      </div>
    );
  }

  return <Loading />;
};

export default JWTTokenAuth;
